import { Box, FormControl, MenuItem, Select } from '@mui/material'
import React, { useEffect, useState } from 'react'
import dayjs from 'dayjs'
import PieChart from "highcharts-react-official";
import Highcharts from 'highcharts/highcharts'
import { postData } from '../../services/api';
Highcharts.setOptions({
    lang: {
        thousandsSep: ','
    }
});

export default function ByCatalogs({ types, budgetYears, seasons }) {
    const [season, setSeason] = useState('all')
    const [type, setType] = useState('all')
    const [years, setYear] = useState(dayjs(new Date()).add(3, 'month').format('BBBB'))
    const [data, setData] = useState([])
    const [isLoading, setIsLoading] = useState(false)
    const getData = async () => {
        const body = {
            BranchNo: [],
            Season:
                season === 'all' ? [] : [season]
            ,
            TypeNo:
                type === 'all' ? [] : [type],
            CatalogNo: [],
            BudgetYear: [years],
            Month: [],
            Day: []
        }
        setIsLoading(true)
        const res = await postData('dashboard/back/production-plan-by-item-catalog-and-branch', body)
        if (res.status === true) {
            setData(res.result)
            setIsLoading(false)
        }
    }
    useEffect(() => {
        getData()
    }, [season, type, years])
    return (
        <>
            <div class="row">
                <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: "space-between" }}>
                    <h2 className='dash-title'>
                        แผนผลิตเมล็ดพันธุ์ข้าว (รายพันธุ์)
                    </h2>
                    <Box sx={{ display: 'flex', flexDirection: { md: "row", xs: 'column' }, justifyContent: "flex-end", '& .backgroundField': { background: "#fdb92e" } }}>
                        <Box className='backgroundField' sx={{ marginRight: '20px', marginBottom: { md: '0', xs: '10px' } }}>
                            <FormControl variant="standard" fullWidth >
                                <Select value={season}
                                    onChange={e => setSeason(e.target.value)}
                                    disableUnderline
                                    MenuProps={{ PaperProps: { sx: { maxHeight: 400 } } }}
                                >
                                    <MenuItem value='all'>ฤดูทั้งหมด</MenuItem>
                                    {seasons?.map((x, i) => (
                                        <MenuItem value={x?.value}>{x?.value}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Box>
                        <Box className='backgroundField' sx={{ marginRight: '20px', marginBottom: { md: '0', xs: '10px' } }}>
                            <FormControl variant="standard" fullWidth >
                                <Select
                                    onChange={e => setYear(e.target.value)}
                                    disableUnderline
                                    value={years || ''}
                                    MenuProps={{ PaperProps: { sx: { maxHeight: 400 } } }}
                                >
                                    {budgetYears?.map((x, i) => (
                                        <MenuItem value={x?.BudgetYear}>{x?.BudgetYear}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Box>
                        <Box className='backgroundField' sx={{ marginRight: '20px', marginBottom: { md: '0', xs: '10px' } }}>
                            <FormControl variant="standard" fullWidth >
                                <Select value={type}
                                    onChange={e => setType(e.target.value)}
                                    disableUnderline
                                    MenuProps={{ PaperProps: { sx: { maxHeight: 400 } } }}
                                >
                                    <MenuItem value='all'>ชนิดข้าวทั้งหมด</MenuItem>
                                    {types?.map((x, i) => (
                                        <MenuItem value={x?.TypeNo}>{x?.TypeName}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Box>
                    </Box>
                </Box>
            </div >
            <div class="row">
                <div class="col-12">
                    {!isLoading && <Dashboard dataDashboard={data} />}
                </div>
            </div>
        </>
    )
}
function Dashboard({ dataDashboard }) {

    let category = [];
    let series = [];
    const colors = [
        '#5ce1e6',
        '#5ce1e6',
        '#38b6ff',
        '#0cc0df',
        '#00BFFF',
        '#00CCFF',
        '#76ABDF',
        '#6CB4EE',
        '#0097b2',
        '#367588',
        '#007791',
        '#008080',
        '#005f69',
        '#007FFF',
        '#318CE7',
        '#4D4DFF',
        '#3457D5',
        '#6082B6',
        '#1560bd',
        '#2774AE',
        '#0000FF',
        '#2E5090',
        '#6A5ACD',
        '#6F00FF',
        '#004687',
        '#034694',
        '#0039a6',

    ]
    if (dataDashboard.length > 0) {
        // for (const x of dataDashboard[0].Detail) {
        //     series.push({
        //         name: x?.InitialsName,
        //         data: [],
        //         type: 'column',
        //     })
        // }
        dataDashboard[0].Detail.map((x, i) => {
            series.push({
                name: x?.InitialsName,
                data: [],
                type: 'column',
                color: colors[i]
            })

        })
        for (let i = 0; i < dataDashboard.length; i++) {
            category.push(dataDashboard[i].CatalogName);
            for (let x = 0; x < dataDashboard[i].Detail.length; x++) {

                series[x].data.push(dataDashboard[i].Detail[x].Target / 1000);
            }

        }
    }
    const options = {
        chart: {
            type: 'column',
            // scrollablePlotArea: {
            //     minWidth: category?.length * 150,
            //     scrollPositionX: 1
            // }
            zoomType: 'x'
        },
        title: {
            text: '',
            align: 'left'
        },
        subtitle: {
            text: 'หน่วย : ตัน',
            align: 'left'
        },
        xAxis: {
            title: {
                text: 'พันธุ์'
            },
            categories: category
        },
        yAxis: {
            min: 0,
            title: null,
            stackLabels: {
                enabled: true
            },
            labels: {
                formatter: function () {
                    return this.value?.toLocaleString();
                }
            },
        },
        legend: {
            enabled: false
        },
        tooltip: {
            headerFormat: '<b>{point.x}</b><br/>',
            pointFormatter: function () {
                var point = this,
                    series = point.series;

                return `${series.name}: <b>${point.y?.toLocaleString()}</b><br/>Total: ${point.stackTotal?.toLocaleString()}`
            },
            // pointFormat: '{series.name}: {point.y}<br/>Total: {point.stackTotal}'
        },

        plotOptions: {
            series: {
                stacking: 'normal',
                borderRadius: 25
            },
            column: {
                stacking: 'normal',
                dataLabels: {
                    enabled: true,
                    color: '#000',
                    style: { fontWeight: 'bolder' },
                    formatter: function () {
                        return this?.y > 0 && `<div style='text-align: center'><span style='font-size:13px'>${this?.series?.userOptions?.name}</span><br/>${this?.y?.toLocaleString()}</div>`
                    },
                    useHTML: true,
                    inside: true,
                }
            }
        },
        series: series
    }
    return (
        <>
            {dataDashboard && <PieChart options={options} highcharts={Highcharts} />}
        </>

    )
}